import { MdStars } from "react-icons/md";
import { defineField, defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";
import { designSystemIconPreview } from "../../components/DesignSystemIconInput";
import { multilingualOrderingField } from "../../common/ordering";

export default defineType({
  name: "suiteClassGenericFeature",
  title: "Suite Class Generic Feature",
  type: "document",
  icon: MdStars,
  preview: {
    select: {
      title: "label",
      icon: "icon"
    },
    prepare: ({ title, icon }) => ({
      title: multilingualStringPreview(title),
      media: designSystemIconPreview(icon)
    })
  },
  orderings: [
    {
      title: "Label",
      name: "labelAsc",
      by: [{ field: multilingualOrderingField("label"), direction: "asc" }]
    }
  ],
  fields: [
    defineField({
      name: "label",
      title: "Label",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "icon",
      title: "Icon",
      type: "designSystemIcon",
      validation: (Rule) => Rule.required()
    })
  ]
});
